import React from 'react';
import './Concept.css';
import dec_img from '../../img/main/bg.gif'
import { Link } from "react-scroll";

const Concept = () => {
    return (
        <div className="concept-wrap" id='concept'>
            <div className="container concept">
                <h2 className='concept-title colorful'>Idea and concept of this event</h2>
                <div className="concept-content">
                    <div className='concept-content_main'>
                        <img className="concept-img concept-item" src={dec_img} alt="" />
                        <div className='concept-text--block concept-item'>
                            <p className="concept-text p1">Join us at the Go Global Summit, the ultimate gathering for passionate GO developers worldwide. Engage in knowledge sharing, innovation, and networking opportunities.</p>
                            <p className="concept-text p1">Explore cutting-edge advancements in GO through engaging keynotes, informative technical sessions, and interactive workshops. Connect with fellow developers, collaborate on exciting projects, and gain valuable insights. Enhance your skills, broaden your network, and stay at the forefront of the GO community.</p>
                            <p className="concept-text p1">Whether you're an experienced GO developer or just starting out, this summit caters to all skill levels. Don't miss out on this must-attend event. Register now and unlock new possibilities for your programming journey with GO at the Go Global Summit!</p>
                            {/* <p className="concept-text p1">Plus, we're hooking you up with certificates to show off your new skills and knowledge.</p>
                            <p className='concept-text concept-text--bold p1'>So, if you're serious about staying ahead of the curve with the latest AI tools in marketing, you gotta hit that button and join our community-driven conference. Let's make moves and level up our game together!</p>
                            <p className='concept-text concept-text--bold p1'>And don't forget about the certificates - we got you covered, fam!</p> */}
                            <Link
                                activeClass="active"
                                to='tickets'
                                spy={true}
                                smooth={true}
                                offset={-94}
                                className='concept-btn button'
                            >
                                Join
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Concept;